// extracted by mini-css-extract-plugin
export default {"playBox":"styles_playBox__hwc17","small":"styles_small__k4VK1","margin":"styles_margin__0Ria6","big":"styles_big__uO29a"};